'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// 04/22/1996 - US
var shortMonthDayYearDateFormatLocales = exports.shortMonthDayYearDateFormatLocales = ['en', 'en-US', 'en-US-POSIX'];

// 1996/04/22 - Bhutan, Canada, China, Korea, Taiwan, Hungary, Iran, Japan, Lithuania, Mongolia
var shortYearDayMonthDateFormatLocales = exports.shortYearDayMonthDateFormatLocales = ['dz', 'dz-BT', 'en-CA', 'zh', 'zh-Hans', 'zh-Hans-CN', 'zh-Hans-HK', 'zh-Hans-MO', 'zh-Hans-SG', 'zh-Hant', 'zh-Hant-HK', 'zh-Hant-MO', 'zh-Hant-TW', 'ko', 'ko-KR', 'ta', 'ta-IN', 'ta-LK', 'hu', 'hu-HU', 'fa_IR', 'ja', 'ja-JP', 'lt_LT', 'mn', 'mn-MN'];

var lengthOfUTCDateWithMilliseconds = 13;
var lengthOfUTCDateWithoutMilliseconds = 10;

var convertDateToProperFormat = function convertDateToProperFormat(date) {
  if (typeof date === 'number') {
    var numberLength = date.toString().length;

    if (numberLength === lengthOfUTCDateWithMilliseconds) {
      return new Date(date);
    }

    if (numberLength === lengthOfUTCDateWithoutMilliseconds) {
      return new Date(date * 1000);
    }

    console.warn('Unsupported utc date format');
  }

  // TODO add string check if needed for UA
  return null;
};

/**
 * Date formatter based on locales
 * @param date - Valid date format that can be used like - new Date(date)
 */
var getDate = exports.getDate = function getDate(date) {
  var locales = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : navigator.language;

  var dateToUse = convertDateToProperFormat(date);

  if (!dateToUse) {
    return null;
  }

  var day = dateToUse.getDate().toString().padStart(2, 0);
  var month = (dateToUse.getMonth() + 1).toString().padStart(2, 0);
  var year = dateToUse.getFullYear();

  if (shortMonthDayYearDateFormatLocales.includes(locales)) {
    return month + '/' + day + '/' + year;
  }

  if (shortYearDayMonthDateFormatLocales.includes(locales)) {
    return year + '/' + month + '/' + day;
  }

  return day + '/' + month + '/' + year;
};

/**
 * Time formatter based on locales
 * @param date - Valid date format that can be used like - new Date(date)
 */
var getTime = exports.getTime = function getTime(date) {
  var locales = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : navigator.language;

  var dateToUse = convertDateToProperFormat(date);

  if (!dateToUse) {
    return null;
  }

  var localesHour = Intl.DateTimeFormat(locales, { hour: 'numeric' }).format(dateToUse);
  var shouldUse12hFormat = /AM|PM/.test(localesHour);
  var dayPeriodLabel = dateToUse.getHours() >= 12 ? 'PM' : 'AM';
  var hours = parseInt(localesHour, 10).toString().padStart(2, 0);
  var minutes = parseInt(dateToUse.getMinutes(), 10).toString().padStart(2, 0);

  if (shouldUse12hFormat) {
    return hours + ':' + minutes + ' ' + dayPeriodLabel;
  }

  return hours + ':' + minutes;
};